import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import store from './store/index';
import './scss/main.scss';
import App from './App';
import { ServiceWorkerProvider } from './hooks/useServiceWorker';
import path from 'path';

function getMainJsFilename() {
  const script = document.currentScript || document.querySelector('script[src|="main"]');
  let filename = '';

  try {
    filename = path.basename(script.src);
  } catch (error) {
    filename = '';
  }

  return filename;
}

// 取的載入的main js filename 用於判斷需不需要更新
const mainJsFilename = getMainJsFilename();

ReactDOM.render((
  <Provider store={store}>
    <ServiceWorkerProvider>
      <Router>
        <Route path="/">
          <App mainJsFilename={mainJsFilename} />
        </Route>
      </Router>
    </ServiceWorkerProvider>
  </Provider>
), document.getElementById('root'));
